export default "__VITE_ASSET__vihU1GAW__";